import * as accordionPane from './accordion.m.css';
import * as avatar from './avatar.m.css';
import * as breadcrumbGroup from './breadcrumb-group.m.css';
import * as button from './button.m.css';
import * as calendar from './calendar.m.css';
import * as card from './card.m.css';
import * as checkboxGroup from './checkbox-group.m.css';
import * as checkbox from './checkbox.m.css';
import * as chipTypeahead from './chip-typeahead.m.css';
import * as chip from './chip.m.css';
import * as dateInput from './date-input.m.css';
import * as dialog from './dialog.m.css';
import * as floatingActionButton from './floating-action-button.m.css';
import * as form from './form.m.css';
import * as gridBody from './grid-body.m.css';
import * as gridCell from './grid-cell.m.css';
import * as gridFooter from './grid-footer.m.css';
import * as gridHeader from './grid-header.m.css';
import * as gridPaginatedFooter from './grid-paginated-footer.m.css';
import * as gridPlaceholderRow from './grid-placeholder-row.m.css';
import * as gridRow from './grid-row.m.css';
import * as grid from './grid.m.css';
import * as headerCard from './header-card.m.css';
import * as header from './header.m.css';
import * as helperText from './helper-text.m.css';
import * as icon from './icon.m.css';
import * as label from './label.m.css';
import * as listItem from './list-item.m.css';
import * as list from './list.m.css';
import * as loadingIndicator from './loading-indicator.m.css';
import * as menuItem from './menu-item.m.css';
import * as nativeSelect from './native-select.m.css';
import * as pagination from './pagination.m.css';
import * as passwordInput from './password-input.m.css';
import * as popup from './popup.m.css';
import * as popupConfirmation from './popup-confirmation.m.css';
import * as progress from './progress.m.css';
import * as radioGroup from './radio-group.m.css';
import * as radio from './radio.m.css';
import * as rangeSlider from './range-slider.m.css';
import * as rate from './rate.m.css';
import * as result from './result.m.css';
import * as select from './select.m.css';
import * as slidePane from './slide-pane.m.css';
import * as slider from './slider.m.css';
import * as snackbar from './snackbar.m.css';
import * as speedDial from './speed-dial.m.css';
import * as wizard from './wizard.m.css';
import * as switchControl from './switch.m.css';
import * as tabContainer from './tab-container.m.css';
import * as textArea from './text-area.m.css';
import * as text from './text.m.css';
import * as textInput from './text-input.m.css';
import * as threeColumnLayout from './three-column-layout.m.css';
import * as timePicker from './time-picker.m.css';
import * as titlePane from './title-pane.m.css';
import * as tooltip from './tooltip.m.css';
import * as tree from './tree.m.css';
import * as twoColumnLayout from './two-column-layout.m.css';
import * as typeahead from './typeahead.m.css';
import * as stack from './stack.m.css';
import * as defaultVariant from './variants/default.m.css';
import * as darkVariant from './variants/dark.m.css';

export default {
	theme: {
		'@dojo/widgets/accordion': accordionPane,
		'@dojo/widgets/avatar': avatar,
		'@dojo/widgets/breadcrumb-group': breadcrumbGroup,
		'@dojo/widgets/button': button,
		'@dojo/widgets/calendar': calendar,
		'@dojo/widgets/checkbox-group': checkboxGroup,
		'@dojo/widgets/checkbox': checkbox,
		'@dojo/widgets/card': card,
		'@dojo/widgets/chip': chip,
		'@dojo/widgets/date-input': dateInput,
		'@dojo/widgets/dialog': dialog,
		'@dojo/widgets/floating-action-button': floatingActionButton,
		'@dojo/widgets/form': form,
		'@dojo/widgets/grid-body': gridBody,
		'@dojo/widgets/grid-cell': gridCell,
		'@dojo/widgets/grid-footer': gridFooter,
		'@dojo/widgets/grid-header': gridHeader,
		'@dojo/widgets/grid-paginated-footer': gridPaginatedFooter,
		'@dojo/widgets/grid-placeholder-row': gridPlaceholderRow,
		'@dojo/widgets/grid-row': gridRow,
		'@dojo/widgets/grid': grid,
		'@dojo/widgets/header-card': headerCard,
		'@dojo/widgets/header': header,
		'@dojo/widgets/helper-text': helperText,
		'@dojo/widgets/icon': icon,
		'@dojo/widgets/label': label,
		'@dojo/widgets/list-item': listItem,
		'@dojo/widgets/loading-indicator': loadingIndicator,
		'@dojo/widgets/list': list,
		'@dojo/widgets/menu-item': menuItem,
		'@dojo/widgets/chip-typeahead': chipTypeahead,
		'@dojo/widgets/native-select': nativeSelect,
		'@dojo/widgets/pagination': pagination,
		'@dojo/widgets/password-input': passwordInput,
		'@dojo/widgets/popup-confirmation': popupConfirmation,
		'@dojo/widgets/progress': progress,
		'@dojo/widgets/popup': popup,
		'@dojo/widgets/radio-group': radioGroup,
		'@dojo/widgets/radio': radio,
		'@dojo/widgets/range-slider': rangeSlider,
		'@dojo/widgets/rate': rate,
		'@dojo/widgets/result': result,
		'@dojo/widgets/select': select,
		'@dojo/widgets/slide-pane': slidePane,
		'@dojo/widgets/slider': slider,
		'@dojo/widgets/snackbar': snackbar,
		'@dojo/widgets/speed-dial': speedDial,
		'@dojo/widgets/wizard': wizard,
		'@dojo/widgets/switch': switchControl,
		'@dojo/widgets/tab-container': tabContainer,
		'@dojo/widgets/text': text,
		'@dojo/widgets/text-area': textArea,
		'@dojo/widgets/text-input': textInput,
		'@dojo/widgets/three-column-layout': threeColumnLayout,
		'@dojo/widgets/time-picker': timePicker,
		'@dojo/widgets/title-pane': titlePane,
		'@dojo/widgets/tooltip': tooltip,
		'@dojo/widgets/tree': tree,
		'@dojo/widgets/two-column-layout': twoColumnLayout,
		'@dojo/widgets/typeahead': typeahead,
		'@dojo/widgets/stack': stack
	},
	variants: {
		default: defaultVariant,
		light: defaultVariant,
		dark: darkVariant
	}
};
